import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap'
import {
  toggle,
  setPublic,
  setCurrentTab,
  resetSelectedItems,
  setAssignSearchValue,
  setHideSelectedOrgGroups,
  setShowSelectedOrgGroups,
  toggleUsers,
  toggleStores,
  toggleRoles,
  toggleLocationGroups,
  setHideSelectedLocationGroups,
  setHideSelectedStores,
  setShowSelectedLocationGroups,
  setShowSelectedRoles,
  onDateChange,
  setShowSelectedUsers,
  setShowSelectedStores,
  setShowSelectedLocations,
  setHideSelectedUsers,
  setHideSelectedRoles,
  toggleOrgGroups,
  toggleMessage,
  onChange,
  toggleEditMessage,
  onChangeEditMessage,
  onSubmitEditMessage,
  onSubmit,
} from 'store/commboard/actions'
import {
  fetchRoles,
  fetchGroups,
  setHideSelectedLocations,
} from 'store/Group/actions'

import AxiosInstance from 'utils/AxiosInstance'
import AssignTabs from '../../../AssignTabs'
import Search from '../../../Search'
import TextEditor from '../../../TextEditor'
import DatePicker from './DatePicker'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarDays } from '@fortawesome/free-solid-svg-icons'

import './style.css'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
import { fetchMessages } from 'store/commboard/actions'
import { setMessagesFetched } from 'store/Dashboard/actions'

function TextEditorModal(props) {
  const commboard = useSelector((state) => state.commboard)
  const groups = useSelector((state) => state.groups)

  const { messages } = useSelector((state) => state.commboard)

  const { users } = useSelector((state) => state.users)

  const languageRedux = useSelector((state) => state.language?.language?.data)
  const language = languageRedux || {}

  const [groupOrgs, setGroupOrgs] = useState([])
  // const [users, setUsers] = useState([])
  // const [soters, setStores] = useState([])
  const { stores: soters } = useSelector((state) => state.stores)

  const dispatch = useDispatch()

  const onAddChange = (property, value) => {
    dispatch(onChange(property, value))
  }

  const onEditMessage = (property, value) => {
    dispatch(onChangeEditMessage(property, value))
  }

  const fetchOrgGroups = () => {
    AxiosInstance.get(`/groups/orgs`).then((data) => setGroupOrgs(data))
  }

  // const fetchUsers = () => {
  //   console.log('leart89')
  //   AxiosInstance.get('/users').then((data) => {
  //     if (Array.isArray(data)) {
  //       data = data.map((item) => {
  //         return {
  //           ...item,
  //           avatar:
  //             typeof item.avatar === 'string' ? JSON.parse(item.avatar) : null,
  //         }
  //       })

  //       setUsers(data)
  //     }
  //   })
  // }

  // const fetchStores = async () => {
  //   await AxiosInstance.get(`/stores`).then((stores) => {
  //     const formatedStores = []

  //     if (Array.isArray(stores)) {
  //       stores.map((item) => {
  //         formatedStores.push({
  //           ...item,
  //           status: item.status === 'Active' ? true : false,
  //         })
  //       })
  //     }

  //     setStores(formatedStores)
  //   })
  // }

  const toggleTabs = {
    toggleOrgGroups,
    toggleUsers,
    toggleLocationGroups,
    toggleStores,
    toggleRoles,
  }

  const hideSelectFunctions = {
    setHideSelectedOrgGroups,
    setHideSelectedLocationGroups,
    setHideSelectedLocations,
    setHideSelectedRoles,
    setHideSelectedStores,
    setHideSelectedUsers,
  }

  const showSelectFunctions = {
    setShowSelectedOrgGroups,
    setShowSelectedUsers,
    setShowSelectedStores,
    setShowSelectedRoles,
    setShowSelectedLocations,
    setShowSelectedLocationGroups,
  }

  useEffect(() => {
    // fetchOrgGroups()
    // fetchUsers()
    // fetchStores()
    // dispatch(fetchGroups())
    // dispatch(fetchRoles())
    console.log('🚨', language.general)
  }, [])

  const items = {
    groupOrgs: groups.groupOrgs,
    users: users,
    stores: soters,
    locationGroups: groups.locationGroups,
    roles: groups.roles,
  }

  // const onSubmit = (event) => {
  //   // event.preventDefault();

  //   // Dispatch form submission
  //   dispatch(onSubmit(event))

  //   // Dispatch toggle
  //   dispatch(toggle())

  //   // Delay fetching messages by 1 second
  //   // setTimeout(() => {
  //   //   dispatch(fetchMessages())
  //   // }, 1250) // 1-second delay
  // }

  return (
    <div className='scrollbar'>
      <Modal
        className='modal-dialog-centered'
        size='lg'
        isOpen={props.isOpen}
        toggle={() =>
          commboard.isShowing
            ? dispatch(toggle())
            : commboard.isShowingEditMessage
            ? dispatch(toggleEditMessage(null, null))
            : dispatch(toggleMessage(''))
        }
        scrollable
      >
        <ModalHeader
          className='border-bottom py-3'
          toggle={() =>
            commboard.isShowing
              ? dispatch(toggle())
              : commboard.isShowingEditMessage
              ? dispatch(toggleEditMessage(null, null))
              : dispatch(toggleMessage(''))
          }
        >

          {!commboard.isShowingEditMessage
            ? language.general
              ? language.general.message
              : null
            : language.general
            ? `Edit ${language.general.message}`
            : null}
          {/* {language.general ? language.general.message : null} */}
        </ModalHeader>
        <ModalBody className='px-0 pt-0 scrollbar'>
          {commboard.isShowingEditMessage ? (
            <div
              className='col-3 mt-2'
              style={{ position: 'relative', zIndex: '9999' }}
            >
              <DatePicker
                date={
                  commboard.expirationDate !== null
                    ? commboard.expirationDate
                    : null
                }
                onDateChange={onDateChange}
                disabled={props.welcomeMessage}
              />
              <FontAwesomeIcon
                icon={faCalendarDays}
                className='dashboard-fixed-icon '
                // size='sm'
              />
            </div>
          ) : null}
          {commboard.isShowing ? (
            <div
              className='col-3 mt-2 mb-0'
              style={{ position: 'relative', zIndex: '9999' }}
            >
              <DatePicker
                // date={commboard.expirationDate}
                onDateChange={onDateChange}
                disabled={props.welcomeMessage}
              />{' '}
              <FontAwesomeIcon
                icon={faCalendarDays}
                className='dashboard-fixed-icon '
                // size='sm'
              />
            </div>
          ) : null}
          {commboard.isShowingEditMessage && (
            <form action='' onSubmit={(e) => dispatch(onSubmitEditMessage(e))}>
              <div className='px-3 pt-2'>
                <TextEditor
                  isOpen={commboard.isShowingEditMessage}
                  setIsOpen={props.textEditorModal}
                  textContent={commboard.message}
                  onChangeText={(e) => onEditMessage(e)}
                />
              </div>
              {commboard.isShowingEditMessage && (
                <div className='row' style={{ margin: '20px 0' }}>
                  <div className='mar-top-20 mar-bot-20 col d-flex justify-content-between align-items-center'>
                    <div className='col-8 d-flex align-items-center my-4'>
                      <div className='custom-control custom-radio  mr-3'>
                        <input
                          className='custom-control-input mr-2'
                          type='radio'
                          name='accessible'
                          id='set-public'
                          checked={commboard.scope === 'public'}
                          onChange={() => dispatch(setPublic('public'))}
                        />
                        <label
                          className='custom-control-label'
                          htmlFor='set-public'
                        >
                          {language.my_library
                            ? language.my_library.public
                            : null}
                        </label>
                      </div>

                      <div className='custom-control custom-radio '>
                        <input
                          className='custom-control-input mr-2'
                          type='radio'
                          name='accessible'
                          id='set-private'
                          checked={commboard.scope === 'private'}
                          onChange={() => dispatch(setPublic('private'))}
                        />
                        <label
                          className='custom-control-label'
                          htmlFor='set-private'
                        >
                          {language.my_library
                            ? language.my_library.private
                            : null}
                        </label>
                      </div>
                    </div>
                    <div>
                      {commboard.scope !== 'private' ? (
                        <SubmitModalButton />
                      ) : null}
                    </div>
                  </div>
                  {commboard.scope === 'private' ? (
                    <div className='col-5 mar-top-20 mar-bot-20'>
                      <Search
                        placeholder='Search'
                        value={props.assignSearchValue}
                        onChange={(event) =>
                          dispatch(setAssignSearchValue(event.target.value))
                        }
                      />
                    </div>
                  ) : null}
                  {commboard.scope === 'private' ? (
                    <div className='col-12 '>
                      <div className='nav-wrapper'>
                        <Nav
                          className='nav-fill flex-column flex-sm-row col-10 p-2 rounded '
                          id='tabs-text'
                          style={{ backgroundColor: '#f6f9fc' }}
                          pills
                          role='tablist'
                        >
                          <NavItem className='nav-items'>
                            <NavLink
                              aria-selected={
                                commboard.currentTab === 'category'
                              }
                              className={`mb-sm-3 mb-md-0 py-1 text-dark bg-transparent font-weight-bold 
																${commboard.currentTab === 'category' ? 'active-item' : 'nav-item'}`}
                              onClick={(e) =>
                                dispatch(
                                  setCurrentTab(
                                    e,
                                    'category',
                                    'selectedOrgGroups',
                                    'groupOrgs',
                                    'toggleOrgGroups',
                                    'showSelectedOrgGroups',
                                    'setShowSelectedOrgGroups',
                                    'setHideSelectedOrgGroups'
                                  )
                                )
                              }
                              href='#pablo'
                              role='tab'
                              size='sm'
                            >
                              {language.general
                                ? language.general.category
                                : 'Category'}
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              aria-selected={commboard.currentTab === 'user'}
                              className={`mb-sm-3 mb-md-0 py-1 text-dark bg-transparent font-weight-bold 
													${commboard.currentTab === 'user' ? 'active-item' : 'nav-item'}`}
                              onClick={(e) =>
                                dispatch(
                                  setCurrentTab(
                                    e,
                                    'user',
                                    'selectedUsers',
                                    'users',
                                    'toggleUsers',
                                    'showSelectedUsers',
                                    'setShowSelectedUsers',
                                    'setHideSelectedUsers'
                                  )
                                )
                              }
                              href='#pablo'
                              role='tab'
                              color='none'
                            >
                              {language.general
                                ? language.general.users
                                : 'Users'}
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              aria-selected={
                                commboard.currentTab === 'location-group'
                              }
                              className={`mb-sm-3 mb-md-0 py-1 text-dark bg-transparent font-weight-bold 
																${commboard.currentTab === 'location-group' ? 'active-item' : 'nav-item'}`}
                              onClick={(e) =>
                                dispatch(
                                  setCurrentTab(
                                    e,
                                    'location-group',
                                    'selectedLocationGroups',
                                    'locationGroups',
                                    'toggleLocationGroups',
                                    'showSelectedLocationGroups',
                                    'setShowSelectedLocationGroups',
                                    'setHideSelectedLocationGroups'
                                  )
                                )
                              }
                              href='#pablo'
                              role='tab'
                            >
                              {language.general
                                ? language.general.location_categories
                                : 'Location Groups'}
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              aria-selected={commboard.currentTab === 'stores'}
                              className={`mb-sm-3 mb-md-0 py-1 text-dark bg-transparent font-weight-bold 
													${commboard.currentTab === 'stores' ? 'active-item' : 'nav-item'}`}
                              onClick={(e) =>
                                dispatch(
                                  setCurrentTab(
                                    e,
                                    'stores',
                                    'selectedStores',
                                    'stores',
                                    'toggleStores',
                                    'showSelectedStores',
                                    'setShowSelectedStores',
                                    'setHideSelectedStores'
                                  )
                                )
                              }
                              href='#pablo'
                              role='tab'
                            >
                              {language.settings
                                ? language.settings.location
                                : 'Location'}
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              aria-selected={
                                commboard.currentTab === 'job-title'
                              }
                              className={`mb-sm-3 mb-md-0 py-1 text-dark bg-transparent font-weight-bold 
																${commboard.currentTab === 'job-title' ? 'active-item' : 'nav-item'}`}
                              onClick={(e) =>
                                dispatch(
                                  setCurrentTab(
                                    e,
                                    'job-title',
                                    'selectedRoles',
                                    'roles',
                                    'toggleRoles',
                                    'showSelectedRoles',
                                    'setShowSelectedRoles',
                                    'setHideSelectedRoles'
                                  )
                                )
                              }
                              href='#pablo'
                              role='tab'
                            >
                              {language.settings
                                ? language.settings.assign_job_title
                                : 'Job Title'}
                            </NavLink>
                          </NavItem>
                        </Nav>
                      </div>
                      <AssignTabs
                        items={items[commboard.currentItems]}
                        toggleItem={toggleTabs[commboard.currentToggleFunction]}
                        selectedItems={commboard.currentSelectedItems}
                        mainProps={commboard}
                        assignSearchValue={commboard.assignSearchValue}
                        setHideSelectedItems={
                          hideSelectFunctions[
                            commboard.currentHideSelectedItemsFunction
                          ]
                        }
                        setShowSelectedItems={
                          showSelectFunctions[
                            commboard.currentShowSelectedItemsFunction
                          ]
                        }
                        showSelectedItems={
                          commboard[commboard.currentShowSelectedItems]
                        }
                        // language={props.language}
                        resetSelectedItems={resetSelectedItems}
                        setCurrentTab={setCurrentTab}
                        setAssignSearchValue={setAssignSearchValue}
                        setPublic={setPublic}
                        enableCategories={true}
                      />
                      <div className='text-right mt-1'>
                        <SubmitModalButton text='Save changes' />
                      </div>
                    </div>
                  ) : null}
                </div>
              )}
            </form>
          )}
          {commboard.isShowing && (
            <form
              action=''
              onSubmit={(e) => {
                dispatch(onSubmit(e))
              }}
            >
              <div className='px-3 pt-2'>
                <TextEditor
                  isOpen={commboard.isShowingEditMessage}
                  setIsOpen={props.textEditorModal}
                  textContent={commboard.body}
                  onChangeText={(e) => onAddChange(e)}
                />
              </div>
              {commboard.isShowing && (
                <div className='row' style={{ margin: '20px 0' }}>
                  <div className='mar-top-20 mar-bot-20 col d-flex justify-content-between'>
                    <div className='d-flex align-items-center '>
                      <div className='custom-control custom-radio  mr-3'>
                        <input
                          className='custom-control-input mr-2'
                          type='radio'
                          name='accessible'
                          id='set-public'
                          checked={commboard.scope === 'public'}
                          onChange={() => dispatch(setPublic('public'))}
                        />
                        <label
                          className='custom-control-label'
                          htmlFor='set-public'
                        >
                          Public
                        </label>
                      </div>

                      <div className='custom-control custom-radio '>
                        <input
                          className='custom-control-input mr-2'
                          type='radio'
                          name='accessible'
                          id='set-private'
                          checked={commboard.scope === 'private'}
                          onChange={() => dispatch(setPublic('private'))}
                        />
                        <label
                          className='custom-control-label'
                          htmlFor='set-private'
                        >
                          Private
                        </label>
                      </div>
                    </div>
                    {commboard.scope !== 'private' ? (
                      <Button
                        className='ml-auto px-5 py-2'
                        color='info'
                        type='submit'
                      >
                        Share
                      </Button>
                    ) : null}
                  </div>
                  {commboard.scope === 'private' ? (
                    <div className='col-5 mar-top-20 mar-bot-20'>
                      <Search
                        placeholder='Search'
                        value={props.assignSearchValue}
                        onChange={(event) =>
                          dispatch(setAssignSearchValue(event.target.value))
                        }
                      />
                    </div>
                  ) : null}
                  {commboard.scope === 'private' ? (
                    <div className='col-12 '>
                      <div className='nav-wrapper nav-center'>
                        <Nav
                          className='nav-fill flex-column flex-sm-row col-10 p-2 rounded '
                          id='tabs-text'
                          style={{ backgroundColor: '#f6f9fc' }}
                          pills
                          role='tablist'
                        >
                          <NavItem className='nav-items'>
                            <NavLink
                              aria-selected={
                                commboard.currentTab === 'category'
                              }
                              className={`mb-sm-3 mb-md-0 py-1 text-dark bg-transparent font-weight-bold 
																${commboard.currentTab === 'category' ? 'active-item' : 'nav-item'}`}
                              onClick={(e) =>
                                dispatch(
                                  setCurrentTab(
                                    e,
                                    'category',
                                    'selectedOrgGroups',
                                    'groupOrgs',
                                    'toggleOrgGroups',
                                    'showSelectedOrgGroups',
                                    'setShowSelectedOrgGroups',
                                    'setHideSelectedOrgGroups'
                                  )
                                )
                              }
                              href='#pablo'
                              role='tab'
                              size='sm'
                            >
                              {language.general
                                ? language.general.category
                                : 'Category'}
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              aria-selected={commboard.currentTab === 'user'}
                              className={`mb-sm-3 mb-md-0 py-1 text-dark bg-transparent font-weight-bold 
													${commboard.currentTab === 'user' ? 'active-item' : 'nav-item'}`}
                              onClick={(e) =>
                                dispatch(
                                  setCurrentTab(
                                    e,
                                    'user',
                                    'selectedUsers',
                                    'users',
                                    'toggleUsers',
                                    'showSelectedUsers',
                                    'setShowSelectedUsers',
                                    'setHideSelectedUsers'
                                  )
                                )
                              }
                              href='#pablo'
                              role='tab'
                              color='none'
                            >
                              {language.general
                                ? language.general.users
                                : 'Users'}
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              aria-selected={
                                commboard.currentTab === 'location-group'
                              }
                              className={`mb-sm-3 mb-md-0 py-1 text-dark bg-transparent font-weight-bold 
																${commboard.currentTab === 'location-group' ? 'active-item' : 'nav-item'}`}
                              onClick={(e) =>
                                dispatch(
                                  setCurrentTab(
                                    e,
                                    'location-group',
                                    'selectedLocationGroups',
                                    'locationGroups',
                                    'toggleLocationGroups',
                                    'showSelectedLocationGroups',
                                    'setShowSelectedLocationGroups',
                                    'setHideSelectedLocationGroups'
                                  )
                                )
                              }
                              href='#pablo'
                              role='tab'
                            >
                              {language.general
                                ? language.general.location_categories
                                : 'Location Groups'}
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              aria-selected={commboard.currentTab === 'stores'}
                              className={`mb-sm-3 mb-md-0 py-1 text-dark bg-transparent font-weight-bold 
													${commboard.currentTab === 'stores' ? 'active-item' : 'nav-item'}`}
                              onClick={(e) =>
                                dispatch(
                                  setCurrentTab(
                                    e,
                                    'stores',
                                    'selectedStores',
                                    'stores',
                                    'toggleStores',
                                    'showSelectedStores',
                                    'setShowSelectedStores',
                                    'setHideSelectedStores'
                                  )
                                )
                              }
                              href='#pablo'
                              role='tab'
                            >
                              {language.settings
                                ? language.settings.location
                                : 'Location'}
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              aria-selected={
                                commboard.currentTab === 'job-title'
                              }
                              className={`mb-sm-3 mb-md-0 py-1 text-dark bg-transparent font-weight-bold 
																${commboard.currentTab === 'job-title' ? 'active-item' : 'nav-item'}`}
                              onClick={(e) =>
                                dispatch(
                                  setCurrentTab(
                                    e,
                                    'job-title',
                                    'selectedRoles',
                                    'roles',
                                    'toggleRoles',
                                    'showSelectedRoles',
                                    'setShowSelectedRoles',
                                    'setHideSelectedRoles'
                                  )
                                )
                              }
                              href='#pablo'
                              role='tab'
                            >
                              {language.settings
                                ? language.settings.assign_job_title
                                : 'Job Title'}
                            </NavLink>
                          </NavItem>
                        </Nav>
                      </div>
                      {console.log('leart712', items[commboard.currentItems])}
                      <AssignTabs
                        items={items[commboard.currentItems]}
                        toggleItem={toggleTabs[commboard.currentToggleFunction]}
                        selectedItems={commboard.currentSelectedItems}
                        mainProps={commboard}
                        assignSearchValue={commboard.assignSearchValue}
                        setHideSelectedItems={
                          hideSelectFunctions[
                            commboard.currentHideSelectedItemsFunction
                          ]
                        }
                        setShowSelectedItems={
                          showSelectFunctions[
                            commboard.currentShowSelectedItemsFunction
                          ]
                        }
                        showSelectedItems={
                          commboard[commboard.currentShowSelectedItems]
                        }
                        // language={props.language}
                        resetSelectedItems={resetSelectedItems}
                        setCurrentTab={setCurrentTab}
                        setAssignSearchValue={setAssignSearchValue}
                        setPublic={setPublic}
                        enableCategories={true}
                        resetModal={commboard.toggleModal}
                      />
                      <div className='d-flex justify-content-end mt-1'>
                        <Button
                          className='ml-auto px-5 py-2 mt-2'
                          color='info'
                          type='submit'
                        >
                          Share
                        </Button>
                      </div>
                    </div>
                  ) : null}
                </div>
              )}
            </form>
          )}
          {commboard.isShowingMessage && (
            <div style={{ minHeight: '500px' }}>
              <div
                className='sun-editor-editable'
                dangerouslySetInnerHTML={{ __html: commboard.message }}
                style={{ wordBreak: 'break-word', fontSize: '14px' }}
              />
            </div>
          )}
        </ModalBody>
      </Modal>
    </div>
  )
}

export default TextEditorModal
